declare var require: any;
import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { Observable } from "rxjs";
const content = require("../../assets/i18n/en.json");

export class TranslateHttpLoader implements TranslateLoader {
  isOnline: boolean;

  constructor(
    private http: HttpClient,
    public prefix: string = "/assets/i18n/",
    public suffix: string = ".json"
  ) {
    this.isOnline = window.navigator.onLine;
  }

  public getTranslation(lang: string): Observable<Object> {
    const url = `${this.prefix}${lang}${this.suffix}`;
    return this.isOnline ? this.http.get(url) : Observable.of(content);
  }
}



// WEBPACK FOOTER //
// ./src/utils/custom-translator-loader/index.ts